import { ThemeProperties } from '../../core';

export interface TextLinkTheme {
	baseText: string;
	baseTextColor: string;
	baseFocusRingColor: string;
	baseIconSize: string;
	baseIconMargin: string;

	activeTextColor: string;

	smallText: string;
	smallIconSize: string;
	smallIconMargin: string;

	mediumText: string;
	mediumIconSize: string;
	mediumIconMargin: string;

	largeText: string;
	largeIconSize: string;
	largeIconMargin: string;
}

export const theme = new ThemeProperties('textLink');
